<template>
	<div class="settings-form">
		<h2>Call Campaigns</h2>
		<gutter size="20px" />
		<p>Customize call campaign settings for this account.</p>
		<p-fieldset legend="Duration Settings">
			<div class="control-group">
				<div class="inner">
					<div class="controls">
						<div class="field">
							<label class="flex align-items-center gap-10">
								<p-input-switch v-model="disable_duration_slider" />
								<div>
									Disable Duration Slider<br /><span class="sub-value normal"
										>The users for this account will not be able to adjust the duration of their call campaigns</span
									>
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>
			<div class="control-group">
				<div class="inner">
					<div class="controls">
						<div class="field">
							<label class="flex align-items-center gap-10">
								<p-input-switch v-model="limit_duration" />
								<div>
									Limit Duration Range<br /><span class="sub-value normal"
										>Set a custom range for call campaign duration sliders on this account</span
									>
								</div>
							</label>
						</div>
					</div>
				</div>
			</div>
			<p-fieldset v-if="limit_duration" legend="Custom Duration Range">
				<div class="control-group">
					<div class="inner">
						<div class="controls gap-20">
							<div class="field xs">
								<label class="control-label">Min Duration:</label>
								<p-input-number v-model="duration_range[0]" class="input-align-right" />
							</div>
							<div class="field xs">
								<label class="control-label">Max Duration:</label>
								<p-input-number v-model="duration_range[1]" class="input-align-right" />
							</div>
						</div>
					</div>
				</div>
			</p-fieldset>
		</p-fieldset>
		<gutter size="20px" />
		<div class="actions">
			<div class="flex justify-content-start">
				<p-button label="Save Changes" @click="saveChanges" :loading="save_loading" />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { useMarketplaceStore } from '@/stores/marketplace';
import { mapStores } from 'pinia';
import { get } from 'lodash-es';
import { getAccountSettings, updateAccount } from '@GQL';
import { title } from '@/lib/Filters';

export default {
	name: 'CampaignTypes',
	data() {
		return {
			disable_duration_slider: false,
			limit_duration: false,
			duration_range: [0, 120],
			save_loading: false,
		};
	},
	computed: {
		accountId() {
			if (this.$route.params.account_id) {
				return this.$route.params.account_id;
			} else if (this.$route.params.parent_account_id) {
				return this.$route.params.parent_account_id;
			} else {
				return this.sessionStore.account.id;
			}
		},
		...mapStores(useMarketplaceStore),
	},
	methods: {
		title,
		async getSettings() {
			const settings_result = await getAccountSettings(this.accountId, true);
			this.disable_duration_slider = get(
				settings_result,
				'account.settings.call_campaigns.disable_duration_slider',
				false
			);
			this.limit_duration = get(settings_result, 'account.settings.call_campaigns.limit_duration', false);
			this.duration_range = get(settings_result, 'account.settings.call_campaigns.duration_range', [0, 120]);
		},
		async saveChanges() {
			this.save_loading = true;
			try {
				await updateAccount(this.accountId, {
					settings: {
						call_campaigns: {
							disable_duration_slider: this.disable_duration_slider,
							limit_duration: this.limit_duration,
							duration_range: this.duration_range,
						},
					},
				});
				this.$toast.add({
					severity: 'success',
					summary: 'Successfully saved changes',
					life: 3000,
				});
			} catch (err) {
				this.$toast.add({
					severity: 'error',
					summary: 'Unable to save changes',
					life: 5000,
				});
			} finally {
				this.save_loading = false;
			}
		},
	},
	async mounted() {
		await this.getSettings();
	},
};
</script>

<style lang="less" scoped>
.sub-value.normal {
	font-weight: normal;
}
</style>
